import { IEventrActivity } from "@eventr/common";

/** What a guest can see; the duplicate copy and its dates-page count share this so they match. */
export function guestVisibleActivities(activities?: IEventrActivity[]): IEventrActivity[] {
  return (activities ?? []).filter(
    (item) => typeof item.visibility === "string" && item.visibility.toLowerCase() === "public",
  );
}
